var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('van-empty',{attrs:{"description":"暂无区域或门店的查看权限","image-size":"60%"}},[_c('van-button',{staticClass:"bottom-button",attrs:{"round":"","type":"danger"},on:{"click":_vm.refresh}},[_vm._v("刷新页面")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }